import { fetchGet } from './api';
import { ISchoolLevelGroup } from '../types/school-level-group.type';

export const fetchSchoolLevelGroups = () => fetchGet<ISchoolLevelGroup[]>('school-level-groups');
